export default __webpack_public_path__ + "static/media/checkpoint2.a903b367.txt";